const getTimeParts = (timestamp?: string) => {
	if (timestamp) {
		const date = new Date(timestamp);
		return {
			day: date.getDay(),
			month: date.getMonth(),
			year: date.getFullYear(),
		};
	}
	return {};
};
export const haveSameDay = (aTimestamp?: string, bTimestamp?: string) => {
	if (!aTimestamp && !bTimestamp) return true;
	const fallbackDate = new Date().toISOString();
	const {
		day: aDay,
		month: aMonth,
		year: aYear,
	} = getTimeParts(aTimestamp ?? fallbackDate);
	const {
		day: bDay,
		month: bMonth,
		year: bYear,
	} = getTimeParts(bTimestamp ?? fallbackDate);
	return aDay === bDay && aMonth === bMonth && aYear === bYear;
};
